import styled from 'styled-components';
import { Flex } from '../../layout/Flex';

export const PromoWrapper = styled(Flex).withConfig({ displayName: 'PromoWrapper' }).attrs({
    direction: 'row',
    alignItems: 'center',
    width: '100%',
    borderRadius: 4,
    px: 1,
    py: 1.25,
    spacing: 1.5,
    background: 'var(--control-primary-background)',
})``;
